import { Component } from '@angular/core';

import { UserCrudIndex } from './crud-index';

@Component({
  selector: 'app-user-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
})
export class UserIndexComponent extends UserCrudIndex {
}
